import { Offcanvas, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { AddVerticalInterface } from "./Verticals";
import HelperService from "../../utility/HelperService";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill-new";
import { Upload } from "lucide-react";

interface PropData {
  show: boolean;
  handleClose: () => void;
  data: AddVerticalInterface | null;
}
const AddVertical = (props: PropData) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<AddVerticalInterface & { role?: string }>();
  const [isLoading, setLoading] = useState(false);
  const [bladeTitle, setBladeTitle] = useState("");
  const [selectedUser, setSelectedUser] = useState<AddVerticalInterface | null>(
    null
  );
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);

  useEffect(() => {
    if (props.data) {
      setBladeTitle("Edit Vertical");
      reset(props.data);
      setPreviewUrl(props.data.image || null);
    } else {
      reset({});
      setBladeTitle("Add Vertical");
      setPreviewUrl("");
      setLogoFile(null);

    }
  }, [props.show]);
    const ALLOWED_IMAGE_TYPES = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/svg+xml",
];
const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const input = e.target;
  const file = input.files?.[0];

  if (!file) return;
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    const msg =
      "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

    toast.error(msg);
    setLogoFile(null);
    setPreviewUrl("");
    input.value = ""; 
    return;
  }
  setLogoFile(file);
  setPreviewUrl(URL.createObjectURL(file));
};
  const data = props.data;
  const onSubmit = () => {
    setLoading(true);

    const formValues = watch();
    const id = props.data?._id;

    // Build formData
    const formData = new FormData();
    formData.append("title", formValues.title);
    if (logoFile) {
      formData.append("image", logoFile);
    }

    // 🔥 Select correct API based on add or edit
    const apiCall = id
      ? WebService.fileUploadPutAPI({
        action: `vertical/update/${id}`,
        body: formData,
      })
      : WebService.fileUploadAPI({
        action: `vertical/add`,
        body: formData,
      });

    apiCall
      .then((res: any) => {
        toast.success(id ? "Vertical Updated Successfully." : "Vertical Created Successfully.");
        setLoading(false);
        handleClose();
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.message || "Something went wrong. Please try again later."
        );
        setLoading(false);
      });
  };


  const handleClose = props.handleClose;
  const show = props.show;

  const onCloseModal = (e?: any) => {
    reset({});
    props.handleClose();
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          reset();
          onCloseModal();
        }}
        placement="end"
        className="offcanvas-large"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{bladeTitle}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Name */}
            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                {...register("title", { required: "Please enter title" })}
              />
              {errors.title && (
                <div className="error-message">{errors.title.message}</div>
              )}
            </Form.Group>

            <Form.Label className="label">
              Upload Image <span className="text-danger">*</span>
            </Form.Label>
            <div
              className="upload-image"
              onClick={() => fileInputRef.current?.click()}
              style={{ cursor: "pointer" }}
            >
              {previewUrl ? (
                <>
                  <img
                    src={previewUrl}
                    alt="Image Preview"
                    className="w-100 h-100 object-contain mx-auto"
                  />
                </>
              ) : (
                <div>
                  <Upload size={20} className="text-primary mb-2" />
                  <span className="text-primary text-sm">
                    Click to Upload image
                  </span>
                  {errors.image && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.image.message}
                    </p>
                  )}
                  {logoFile && (
                    <p className="text-sm text-gray-500 mt-1">
                      Selected: {logoFile.name}
                    </p>
                  )}
                </div>
              )}
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </div>
            <p className="text-primary mt-1" style={{ fontSize: "13px" }}>
              Note: Please upload an image of size: <strong>130 × 160 px</strong> in <strong>.png, .jpeg, .jpg or .svg</strong> format.
            </p>

            <div className="d-flex justify-content-end p-3">
              <CustomButton
                isLoading={isLoading}
                label="Save"
                className="w-100"
                type="submit"
                id="saveUserButton"
              />
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AddVertical;
